export const NativeTokens = {
    Main: 'Main',
};
//# sourceMappingURL=native.js.map